import { createAction } from '@reduxjs/toolkit';

import type { NotifPrefs } from '../domain/notif-prefs.model';

/**
 * Signal actions: intents for the saga (side effects, not state transitions).
 * `prefChanged` carries the user id because persistence is per-user and the
 * identity lives in `AuthContext`, not this slice.
 */
export const loadRequested = createAction<string>('notificationPreferences/loadRequested');

export const prefChanged = createAction<{
  userId: string;
  key: keyof NotifPrefs;
  value: boolean;
}>('notificationPreferences/prefChanged');
